"use client";

import {JSX} from "react";

import {useTranslation} from "@/shared/i18n";
import {Typography} from "@/shared/ui/data-display/typography";

import {MONTH_KEYS} from "../constants";

interface CalendarHeaderProps {
    month: number;
    year: number;
    showLeftNav: boolean;
    showRightNav: boolean;
    disableLeftNav?: boolean;
    disablePreviousYear?: boolean;
    onPreviousYear?: () => void;
    onPreviousMonth?: () => void;
    onNextMonth?: () => void;
    onNextYear?: () => void;
}

export function CalendarHeader({
    month,
    year,
    showLeftNav,
    showRightNav,
    disableLeftNav = false,
    disablePreviousYear,
    onPreviousYear,
    onPreviousMonth,
    onNextMonth,
    onNextYear,
}: CalendarHeaderProps): JSX.Element {
    const {t} = useTranslation("calendar");
    const monthKey = MONTH_KEYS[month];
    const yearDisabled = disablePreviousYear ?? disableLeftNav;
    const monthDisabled = disableLeftNav;

    return (
        <div className="daterange-picker-field__header">
            {showLeftNav ? (
                <>
                    <button
                        type="button"
                        onClick={yearDisabled ? undefined : onPreviousYear}
                        className={`daterange-picker-field__nav${yearDisabled ? " daterange-picker-field__nav--disabled" : ""}`}
                        disabled={yearDisabled}
                        aria-label={t("previousYear")}
                    >
                        «
                    </button>
                    <button
                        type="button"
                        onClick={monthDisabled ? undefined : onPreviousMonth}
                        className={`daterange-picker-field__nav${monthDisabled ? " daterange-picker-field__nav--disabled" : ""}`}
                        disabled={monthDisabled}
                        aria-label={t("previousMonth")}
                    >
                        ‹
                    </button>
                </>
            ) : (
                <>
                    <button type="button" className="daterange-picker-field__nav daterange-picker-field__nav--hidden" disabled>
                        «
                    </button>
                    <button type="button" className="daterange-picker-field__nav daterange-picker-field__nav--hidden" disabled>
                        ‹
                    </button>
                </>
            )}

            <Typography as="span" size={16} weight={600} color="title" className="daterange-picker-field__title">
                {t(monthKey)} {year}
            </Typography>

            {showRightNav ? (
                <>
                    <button type="button" onClick={onNextMonth} className="daterange-picker-field__nav" aria-label={t("nextMonth")}>
                        ›
                    </button>
                    <button type="button" onClick={onNextYear} className="daterange-picker-field__nav" aria-label={t("nextYear")}>
                        »
                    </button>
                </>
            ) : (
                <>
                    <button type="button" className="daterange-picker-field__nav daterange-picker-field__nav--hidden" disabled>
                        ›
                    </button>
                    <button type="button" className="daterange-picker-field__nav daterange-picker-field__nav--hidden" disabled>
                        »
                    </button>
                </>
            )}
        </div>
    );
}
